import worldMap from './legacyAfricanMap.json';

export default () => worldMap;
